import * as firebase from 'firebase';
import 'firebase/firestore';

export default function(locale: string) {
    return firebase.app().database().ref('locales').child(locale).once('value').then( (val) => {
        return val.val();
    });
}
